export function SimpleTable({ cols, rows, onRow, testId, rowTestId }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card" data-testid={testId}>
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-muted text-left text-xs uppercase tracking-wider text-muted-foreground">
          <tr>{cols.map((c) => <th key={c.label} scope="col" className="whitespace-nowrap px-4 py-3 font-semibold">{c.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} onClick={onRow ? () => onRow(r) : undefined} data-testid={rowTestId ? rowTestId(r) : undefined}
              tabIndex={onRow ? 0 : undefined} onKeyDown={onRow ? (e) => e.key === "Enter" && onRow(r) : undefined}
              className={`border-t border-border ${onRow ? "cursor-pointer hover:bg-muted/60 focus-visible:bg-muted" : ""}`}>
              {cols.map((c) => <td key={c.label} className="px-4 py-3 align-top">{c.render(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
      {!rows.length && <p className="p-6 text-center text-sm text-muted-foreground" data-testid="table-empty">No records match.</p>}
    </div>
  );
}
